import {SortableContext} from '@dnd-kit/sortable';
import {DataStatus} from 'platform/components';
import {Grid} from 'platform/foundation';

import {ReactNode} from 'react';

import {buildDroppableItemId, Droppable} from '@dms/features/dnd';

import {IMAGE_SIZE} from '../../../constants/imageSize';

interface AlbumPhotoGridProps {
  /** Sortable container id; also the drop target when the grid is empty. */
  containerId: string;
  sortableItemIds: string[];
  isDropDisabled: boolean;
  isLoading?: boolean;
  isError?: boolean;
  children: ReactNode;
}

/** The sortable photo grid of an album: the flat album, the Guide Layout and the Backlog share it. */
export function AlbumPhotoGrid(props: AlbumPhotoGridProps) {
  return (
    <SortableContext id={props.containerId} items={props.sortableItemIds}>
      <Droppable id={buildDroppableItemId(props.containerId)} disabled={props.isDropDisabled}>
        <Grid fill minColumnWidth={IMAGE_SIZE.width} minHeight={IMAGE_SIZE.height} spacing={3}>
          <DataStatus isLoading={props.isLoading ?? false} isError={props.isError ?? false}>
            {props.children}
          </DataStatus>
        </Grid>
      </Droppable>
    </SortableContext>
  );
}
